import dayjs from 'dayjs';
import { queryStockRealtimeKlineHistory } from '@/jmHttp/api/marketStock';
import { isKLineQuoteType } from '@/pages/find/stock/constants';
import { normalizeMinuteQuotations } from './normalizeKlineData';
import { resolveStockKlineCandleMode } from './stockKlineSubscribe';
import { isUndefined } from 'lodash-es';

const US_MARKET_TYPE = 3;
const DEFAULT_KLINE_COUNT = 500;

/**
 * 解包 jmHttp realtime-kline-history 响应（兼容 quotations 在顶层或 data 内）。
 * @param {object|null|undefined} res
 * @returns {object|null}
 */
export function unwrapKlineHistoryPayload(res) {
  if (!res) {
    return null;
  }
  if (Array.isArray(res.quotations) || !isUndefined(res.quotations)) {
    return res;
  }
  if (res.data && (Array.isArray(res.data.quotations) || !isUndefined(res.data.quotations))) {
    return res.data;
  }
  return res;
}

/**
 * 将 realtime-kline-history 的 quotations 规范为图表数据。
 * @param {Array|undefined} quotations
 * @param {{ marketType?: string|number, quoteType?: number }} options
 * @returns {Array}
 */
function normalizeKlineHistoryList(quotations, { marketType, quoteType } = {}) {
  const list = normalizeMinuteQuotations(quotations, { quoteType });
  if (!isKLineQuoteType(quoteType)) {
    return list;
  }
  return list.map((item) => ({
    ...item,
    date: dayjs(item.tradingDay).format('YYYY-MM-DD'),
    turnoverVolume:
      Number(marketType) === US_MARKET_TYPE ? item.turnoverVolumeShares ?? item.turnoverVolume : item.turnoverVolume
  }));
}

/**
 * 请求 K 线历史（分钟 / 日 / 周 / 月统一走 realtime-kline-history）。
 * @param {{
 *   fullCode: string,
 *   quoteType: number,
 *   count?: number,
 *   dataType?: number,
 *   timeIndex?: string,
 *   marketType?: string|number
 * }} params
 * @returns {Promise<{ list: Array, hasMore: boolean }>}
 */
export async function fetchRealtimeKlineHistory({ fullCode, quoteType, count, dataType, timeIndex, marketType }) {
  const code = String(fullCode || '').trim();
  if (!code) {
    return { list: [], hasMore: false };
  }
  const res = await queryStockRealtimeKlineHistory({
    candlePeriod: quoteType,
    fullCode: code,
    count: count ?? DEFAULT_KLINE_COUNT,
    candleMode: resolveStockKlineCandleMode(dataType),
    ...(timeIndex ? { timeIndex } : {})
  });
  const payload = res.data;
  const list = normalizeKlineHistoryList(payload?.quotations, { marketType, quoteType });
  const hasMore = !!payload?.isHaveMore;
  return { list, hasMore };
}
